import React, { useEffect } from "react";
import "../../App.css";
import "../Cards.css";
import CardItem from "../CardItem";

export default function ImprovementNuggets() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div
        className="blog-head-container"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1500856056008-859079534e9e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80)",
        }}
      >
        {/* <video src="assets/videos/video-1.mp4" autoPlay loop muted /> */}
        <h1>Improvement Nuggets</h1>
        <p>
          In these blog posts I share short suggestions for improvement that I
          have developed through failures and reflection.
        </p>
      </div>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="https://images.unsplash.com/photo-1542299642-a194ad3a7199?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80"
              title="Learn Skills Faster"
              label=""
              path="/learn-skills-faster"
              subtitle="metalearning, physical skills"
            />
          </ul>
        </div>
      </div>
    </>
  );
}
